import styled from '@emotion/styled'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import routes from '../../core/routes'
import { mediaQueries } from '../../core/theme'
import { useStore } from '../../stores'
import { RoundBtn } from '../index'
import exitIcon from './img/exit.svg'

const StyledRoundBtn = styled(RoundBtn)`
  ${mediaQueries.medium} {
    margin: 0;
  }
`

const StyledImg = styled.img`
  width: 12px;
  height: 12px;

  ${mediaQueries.medium} {
    width: 17px;
    height: 17px;
  }

  ${mediaQueries.large} {
    width: 21px;
    height: 21px;
  }
`

type ExitGameBtnProps = {
  onExit?: () => void
}

export const ExitGameBtn: FC<ExitGameBtnProps> = observer((props) => {
  const { onExit } = props
  const navigate = useNavigate()
  const { rouletteStore } = useStore()

  return (
    <StyledRoundBtn
      onClick={(e) => {
        e.preventDefault()

        navigate(routes.lobby, {
          replace: true,
        })

        rouletteStore.sendLeftGame(rouletteStore.gameId)

        if (onExit) onExit()
      }}>
      <StyledImg src={exitIcon} alt="exit" width={12} height={12} />
    </StyledRoundBtn>
  )
})

export default ExitGameBtn
